function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 172.5,
  cy: 172,
  stroke: "#C59353",
  strokeWidth: 2,
  opacity: 0.603,
  rx: 171.5,
  ry: 171
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 50,
  r: 15,
  fill: "#C59353"
}));

function SvgGroup44(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345 344"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNDUgMzQ0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzI0IC03NTcwKSB0cmFuc2xhdGUoMTMyNCA3NTcwKSI+CiAgICAgICAgICAgICAgICA8ZWxsaXBzZSBjeD0iMTcyLjUiIGN5PSIxNzIiIHN0cm9rZT0iI0M1OTM1MyIgc3Ryb2tlLXdpZHRoPSIyIiBvcGFjaXR5PSIuNjAzIiByeD0iMTcxLjUiIHJ5PSIxNzEiLz4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjU1IiBjeT0iNTAiIHI9IjE1IiBmaWxsPSIjQzU5MzUzIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgGroup44 as ReactComponent };